import { render, staticRenderFns } from "./CensoComponent.vue?vue&type=template&id=036c0af8&scoped=true&"
import script from "./CensoComponent.vue?vue&type=script&lang=js&"
export * from "./CensoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CensoComponent.vue?vue&type=style&index=0&id=036c0af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c0af8",
  null
  
)

export default component.exports